import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DefaultService } from "src/app/services/default/default.service";
import { CustomActions } from "src/app/utils/custom-actions";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";
import Swal from "sweetalert2";

@Component({
  selector: "app-actions-table",
  templateUrl: "./actions-table.component.html",
  styleUrls: ["./actions-table.component.scss"],
})
export class ActionsTableComponent implements OnInit {
  @Input() row!: any;
  @Input() index: string = "";
  @Input() endpoint: string = "";
  @Input() show_delete_button: boolean = true;
  @Input() show_edit_button: boolean = true;
  @Input() visible_actions: Array<any> = [];
  @Input() invisible_actions: Array<any> = [];
  @Input() multi_actions: Array<any> = [];
  @Input() actions_with_condition: Array<any> = [];

  custom_generated_buttons: Array<any> = [];

  constructor(
    private spinner: NgxSpinnerService,
    private defaultService: DefaultService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    let custom_actions = new CustomActions(
      this.defaultService,
      this.router,
      this.spinner,
      null
    );

    this.custom_generated_buttons =
      custom_actions.generate_custom_buttons_for_table(this.endpoint, this.row);
  }

  navigateTo(actionName: string) {
    Webflow.myAction(this.router, actionName, {});
  }

  delete() {
    Swal.fire({
      title: "Suppression",
      text: "Étes-vous sûre de vouloir supprimer ?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Confirmer`,
      cancelButtonText: `Annuler`,
      cancelButtonColor: "black",
      confirmButtonColor: "#D63333",
    }).then((result) => {
      if (result.isConfirmed) {
        this.activatedRoute.queryParams.subscribe((params) => {
          this.spinner.show();
          this.defaultService
            .delete(this.endpoint, this.row[this.index])
            .subscribe(
              (res) => {
                Swal.fire(
                  "Félicitation",
                  "Suppression effectué avec succés",
                  "success"
                );
                this.redirectTo(this.router.url.split("?")[0], params);
              },
              (error) => {
                if (GenerateErrors.check_if_is_custom_error(error)) {
                  Swal.fire(
                    "Erreur",
                    GenerateErrors.get_message_error(error),
                    "error"
                  );
                } else {
                  Swal.fire("Erreur", "Erreur de connexion", "error");
                }
              }
            )
            .add(() => {
              this.spinner.hide();
            });
        });
      }
    });
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }
}
